import * as React from 'react';
import { GridCell } from '@progress/kendo-react-grid';

export function TableCommandCell({ edit, editModal, remove, add, update, discard, cancel, editField, isNew, getStringRepresentation }) {
    return class extends GridCell {
        render() {
            const { dataItem } = this.props;
            const inEdit = dataItem[editField];
            const isNewItem = isNew(dataItem);

            return inEdit ? (
                <td className="k-command-cell">
                    <button
                        className="k-button k-grid-save-command"
                        onClick={(e) => { e.preventDefault(); isNewItem ? add(dataItem) : update(dataItem) }}
                    >
                        {isNewItem ? 'Add' : 'Update'}
                    </button>
                    <button
                        className="k-button k-grid-cancel-command"
                        onClick={(e) => { e.preventDefault(); isNewItem ? discard(dataItem) : cancel(dataItem) }}
                    >
                        {isNewItem ? 'Discard' : 'Cancel'}
                    </button>
                </td>
            ) : (
                    <td className="k-command-cell">
                        {edit && <button
                            className="k-primary k-button k-grid-edit-command"
                            onClick={(e) => { e.preventDefault(); edit(dataItem) }}
                        >
                            Edit
                    </button>}

                        {editModal &&
                            <button
                                className="k-primary k-button k-grid-edit-command"
                                onClick={(e) => { e.preventDefault(); editModal(dataItem) }}
                            >
                                Edit 2
                    </button>
                        }

                        {remove && <button
                            className="k-button k-grid-remove-command"
                            onClick={(e) => {
                                e.preventDefault(); window.confirm('Confirm deleting: ' + getStringRepresentation(dataItem)) &&
                                    remove(dataItem)
                            }}
                        >
                            Remove
                    </button>}
                    </td>
                );
        }
    }
};